/**
 * Calculates the display index for cycling through a list of children
 * using modular arithmetic for wrap-around behavior.
 *
 * @param skipChild - The current skip/refresh counter
 * @param childrenLength - The total number of children in the fetched results
 * @returns The index into the children array to display
 */
export const getDisplayIndex = (
  skipChild: number,
  childrenLength: number,
): number => {
  if (childrenLength === 0) {
    return 0;
  }
  return skipChild % childrenLength;
};
